import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { YoutubeEmbedVideoComponent } from "../../../new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { MatDialog } from "@angular/material/dialog";
import { formatDate } from "@angular/common";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NotificationService } from "src/app/services/notification.service";
import { AuthService } from "src/app/providers/auth.service";

@Component({
  selector: "sm-upcoming-appointments",
  templateUrl: "./upcoming-appointments.component.html",
  styleUrls: ["./upcoming-appointments.component.scss"],
})
export class UpcomingAppointmentsComponent implements OnInit, OnDestroy {
  repeatArray: any;
  upcomingAppointmentsData: any = [];
  toshowData: boolean = true;
  loader: boolean = false;
  _apisub: Subscription;
  constructor(
    private _apiservice: ApiService,
    private router: Router,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private _snackBar: MatSnackBar,
    private authService:AuthService,
    private route: ActivatedRoute
  ) {
    this.listenForNewBookingUpdates();
    this.listenForBookingStatusUpdates();
    this.listenForMemberAttendance();
    this.listenForMemberBookingStatusUpdate();
    this.listenForBookingAssignmentUpdates();
    this.listenForMemberBookingAssignmentUpdates();
    this._apisub = this._apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_UPCOMING_BOOKINGS_FOR_DASHBOARD
      ) {
        this.upcomingAppointmentsData = [];
        if (resdata.result) {
          resdata.result.forEach((element: any) => {
            if (element.data_type == 1) {
              if (element.booking_type == 0) {
                element.bookingType = "Home service";
              } else if (element.booking_type == 1) {
                element.bookingType = "Shop service";
              } else if (element.booking_type == 2) {
                element.bookingType = "Virtual service";
              }

              if (
                element.appointment_status == 0 ||
                element.appointment_status == 1 ||
                element.appointment_status == 2
              ) {
                element.bookingStat = "New";
              } else if (element.appointment_status == 3) {
                element.bookingStat = "In-progress";
              } else if (element.appointment_status == 4) {
                element.bookingStat = "Completed";
              } else if (element.appointment_status == 5) {
                element.bookingStat = "Confirmed";
              } else if (element.appointment_status == 6) {
                element.bookingStat = "Cancelled";
              } else if (element.appointment_status == 7) {
                element.bookingStat = "Assigned";
              } else if (element.appointment_status == 8) {
                element.bookingStat = "Cancelled";
              } else if (element.appointment_status == 9) {
                element.bookingStat = "In-progress";
              } else {
                element.bookingStat = "--";
              }

              if (
                element.booking_start_time &&
                element.booking_start_time != null
              ) {
                element.booking_start_time = element.booking_start_time.slice(
                  0,
                  5
                );
              }
              if (element.booking_date && element.booking_date != null) {
                const date = new Date(element.booking_date);
                element.u_booking_date = formatDate(
                  date,
                  "MMM d, yyyy",
                  "en-US"
                );
              }
              if (
                element.booking_end_time &&
                element.booking_end_time != null
              ) {
                element.booking_end_time = element.booking_end_time.slice(0, 5);
              }
              element.phone =
                element.country_code + " " + element.customer_phone;
              element.time =
                element.booking_start_time + " - " + element.booking_end_time;
                 if(element.booking_address){
                element.booking_address = typeof element.booking_address == 'string' ? JSON.parse(element.booking_address) : element.booking_address
              }
              this.upcomingAppointmentsData.push(element);
            } else if (element.data_type == 2) {
              if (element.booking_type == 0) {
                element.bookingType = "Home service";
              } else if (element.booking_type == 1) {
                element.bookingType = "Shop service";
              } else if (element.booking_type == 2) {
                element.bookingType = "Virtual service";
              }

              if (element.appointment_status == 0) {
                element.bookingStat = "Absent";
              } else if (element.appointment_status == 1) {
                element.bookingStat = "Present";
              } else {
                element.bookingStat = "Membership";
              }

              if (
                element.booking_start_time &&
                element.booking_start_time != null
              ) {
                element.booking_start_time = element.booking_start_time.slice(
                  0,
                  5
                );
              }
              if (element.booking_date && element.booking_date != null) {
                const weekdays = [
                  "Sunday",
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                ];
                const weekdayIndex = parseInt(element.booking_date, 10) - 1;
                element.u_booking_date = weekdays[weekdayIndex];
              }
              if (
                element.booking_end_time &&
                element.booking_end_time != null
              ) {
                element.booking_end_time = element.booking_end_time.slice(0, 5);
              }
              element.phone =
                element.country_code + " " + element.customer_phone;
              element.time =
                element.booking_start_time + " - " + element.booking_end_time;
              this.upcomingAppointmentsData.push(element);
            }
          });
        }
        if (this.upcomingAppointmentsData.length < 4) {
          this.repeatArray = new Array(
            4 - this.upcomingAppointmentsData.length
          );
        }
        this.loader = false;
      }
    });
  }

  ngOnInit(): void {
    this.loader = true;
    this._apiservice.getUpcomingBookingsForDashboard("4", "1");
  }

  private newbookingsubscription: Subscription = new Subscription();
  listenForNewBookingUpdates() {
    this.newbookingsubscription = this.notificationService
      .getNotificationByType("newBooking")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            //check and update if tomorrows bookings

            this._apiservice.getUpcomingBookingsForDashboard("4", "1");
          }
        }
      });
  }

  private bookingStatusUpdatedsubscription: Subscription = new Subscription();
  listenForBookingStatusUpdates() {
    this.bookingStatusUpdatedsubscription = this.notificationService
      .getNotificationByType("bookingStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            //check and update if tomorrows bookings

            this._apiservice.getUpcomingBookingsForDashboard("4", "1");
          }
        }
      });
  }
  private bookingAssignmentsubscription: Subscription = new Subscription();
  listenForBookingAssignmentUpdates() {
    this.bookingAssignmentsubscription = this.notificationService
      .getNotificationByType("onCustomerAssign")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            //check and update if tomorrows bookings

            this._apiservice.getUpcomingBookingsForDashboard("4", "1");
          }
        }
      });
  }

  private memberattendancesubscription: Subscription = new Subscription();
  listenForMemberAttendance() {
    this.memberattendancesubscription = this.notificationService
      .getNotificationByType("onMemberAttendance")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            //check and update if tomorrows bookings

            this._apiservice.getUpcomingBookingsForDashboard("4", "1");
          }
        }
      });
  }

  private memberbookingstatuschangedsubscription: Subscription =
    new Subscription();
  listenForMemberBookingStatusUpdate() {
    this.memberbookingstatuschangedsubscription = this.notificationService
      .getNotificationByType("memberBookingStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            //check and update if tomorrows bookings

            this._apiservice.getUpcomingBookingsForDashboard("4", "1");
          }
        }
      });
  }
  private memberBookingAssignmentsubscription: Subscription =
    new Subscription();
  listenForMemberBookingAssignmentUpdates() {
    this.memberBookingAssignmentsubscription = this.notificationService
      .getNotificationByType("onMemberAssign")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            //check and update if tomorrows bookings

            this._apiservice.getUpcomingBookingsForDashboard("4", "1");
          }
        }
      });
  }

  viewAll() {
    this.router.navigate(["all-upcoming-appointments"]);
  }

  ngOnDestroy(): void {
    this._apisub.unsubscribe();
    if (this.newbookingsubscription) {
      this.newbookingsubscription.unsubscribe();
    }
    if (this.bookingStatusUpdatedsubscription) {
      this.bookingStatusUpdatedsubscription.unsubscribe();
    }
    if (this.memberattendancesubscription) {
      this.memberattendancesubscription.unsubscribe();
    }
    if (this.memberbookingstatuschangedsubscription) {
      this.memberbookingstatuschangedsubscription.unsubscribe();
    }
    if (this.bookingAssignmentsubscription) {
      this.bookingAssignmentsubscription.unsubscribe();
    }
    if (this.memberBookingAssignmentsubscription) {
      this.memberBookingAssignmentsubscription.unsubscribe();
    }
  }

  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "",
        title: "Upcoming activity",
      },
    });
  }

  bookingDetails(item: any) {
    // this._modelRef.open(CustomerBookingDetailsComponent, {
    //   width: '700px',
    //   data: {
    //     title: 'Bookings Details',
    //     ref: this._modelRef,
    //     data: item.booking_hash,
    //   },
    // });
    this.authService.setUserRole(item.is_owner == 1 ? "owner" : "employee");
    localStorage.setItem(
      SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
      item.employee_hash_id
    );
    localStorage.setItem(
      SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
      item.entity_public_hash_id
    );

    if (item.data_type == 1) {
      this.router.navigate(["booking-details"], {
        relativeTo: this.route,
        queryParams: {
          bookingHash: item.booking_hash,
          entityHash: item.business_hash,
          eph: item.entity_public_hash_id,
        },
      });
    } else if (item.data_type == 2) {
      this.router.navigate(["membership-booking-details"], {
        relativeTo: this.route,
        queryParamsHandling: "merge",
        queryParams: {
          memberHash: item.member_hash,
          isf: "1",
          entityHash: item.business_hash,
          bd: item.booking_date,
        },
      });
    }
  }
}
